var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 18.5,
    height: 18.5,
    rx: 6.28499,
    stroke: "#252525",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2695 12.041H8.77539C8.7793 11.6895 8.80664 11.3867 8.85742 11.1328C8.91211 10.875 9.00391 10.6426 9.13281 10.4355C9.26562 10.2285 9.44141 10.0234 9.66016 9.82031C9.84375 9.65625 10.0039 9.5 10.1406 9.35156C10.2773 9.20312 10.3848 9.05078 10.4629 8.89453C10.541 8.73437 10.5801 8.55664 10.5801 8.36133C10.5801 8.13477 10.5449 7.94727 10.4746 7.79883C10.4082 7.64648 10.3066 7.53125 10.1699 7.45312C10.0371 7.375 9.86914 7.33594 9.66602 7.33594C9.49805 7.33594 9.3418 7.37305 9.19727 7.44727C9.05273 7.51758 8.93359 7.62695 8.83984 7.77539C8.75 7.92383 8.70312 8.11914 8.69922 8.36133H7C7.01172 7.82617 7.13477 7.38477 7.36914 7.03711C7.60742 6.68555 7.92578 6.42578 8.32422 6.25781C8.72266 6.08594 9.16992 6 9.66602 6C10.2129 6 10.6816 6.08984 11.0723 6.26953C11.4629 6.44531 11.7617 6.70508 11.9687 7.04883C12.1758 7.38867 12.2793 7.80273 12.2793 8.29102C12.2793 8.63086 12.2129 8.93359 12.0801 9.19922C11.9473 9.46094 11.7734 9.70508 11.5586 9.93164C11.3437 10.1582 11.1074 10.3926 10.8496 10.6348C10.627 10.834 10.4746 11.043 10.3926 11.2617C10.3145 11.4805 10.2734 11.7402 10.2695 12.041ZM8.59961 13.8516C8.59961 13.6016 8.68555 13.3945 8.85742 13.2305C9.0293 13.0625 9.25977 12.9785 9.54883 12.9785C9.83398 12.9785 10.0625 13.0625 10.2344 13.2305C10.4102 13.3945 10.498 13.6016 10.498 13.8516C10.498 14.0937 10.4102 14.2988 10.2344 14.4668C10.0625 14.6348 9.83398 14.7187 9.54883 14.7187C9.25977 14.7187 9.0293 14.6348 8.85742 14.4668C8.68555 14.2988 8.59961 14.0937 8.59961 13.8516Z",
    fill: "#252525"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.80bffa209ae65d95747c315c04860243.svg";
export { ForwardRef as ReactComponent };